import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import './style.scss';
var SkipNav = function SkipNav(_ref) {
  var className = _ref.className,
    linkClassName = _ref.linkClassName,
    _ref$skipToSearch = _ref.skipToSearch,
    skipToSearch = _ref$skipToSearch === void 0 ? false : _ref$skipToSearch,
    _ref$mainContentId = _ref.mainContentId,
    mainContentId = _ref$mainContentId === void 0 ? 'main-content' : _ref$mainContentId,
    _ref$searchId = _ref.searchId,
    searchId = _ref$searchId === void 0 ? 'search' : _ref$searchId,
    skipToContentText = _ref.skipToContentText,
    skipToSearchText = _ref.skipToSearchText,
    _ref$customLinks = _ref.customLinks,
    customLinks = _ref$customLinks === void 0 ? [] : _ref$customLinks;
  var classes = c('SkipNav', className);
  var linkClasses = c('focusable skip-link', linkClassName);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var defaultContentText = skipToContentText || t('atoms.skip_nav.skipto_content');
  var defaultSearchText = skipToSearchText || t('atoms.skip_nav.skipto_search');
  var links = useMemo(function () {
    var generatedLinks = [];
    generatedLinks.push( /*#__PURE__*/React.createElement("a", {
      key: "skip-to".concat(mainContentId),
      href: "#".concat(mainContentId),
      className: linkClasses
    }, defaultContentText));
    if (skipToSearch) {
      generatedLinks.push( /*#__PURE__*/React.createElement("a", {
        key: "skip-to-search",
        href: "#".concat(searchId),
        className: linkClasses
      }, defaultSearchText));
    }
    if (customLinks.length > 0) {
      customLinks.forEach(function (link) {
        var key = "".concat(link.href, "-").concat(link.text);
        generatedLinks.push( /*#__PURE__*/React.createElement("a", {
          key: key,
          href: link.href,
          className: linkClasses
        }, link.text));
      });
    }
    return generatedLinks;
  }, [mainContentId, skipToSearch, searchId, defaultContentText, defaultSearchText, customLinks, linkClasses]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, links);
};
export default SkipNav;